import styles from './index.module.css'

import React from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { getShortlistBaseRoute } from 'utils/routing'

import Button from 'components/ui/button'
import ButtonContainer from 'components/ui/button-container'
import Heading from 'components/ui/heading'
import Icon from 'components/ui/icon'
import ModalWindow from 'components/ui/modal-window'

const FindArtist = (): React.ReactNode => {
  const params = useParams<{ shortlistId: string }>()
  const navigate = useNavigate()
  const location = useLocation()

  const onClose = () => {
    const baseRoute = getShortlistBaseRoute(location)
    navigate(
      `${baseRoute}/shortlists/${params.shortlistId}/save/presentation`,
      {
        state: location.state,
      },
    )
  }

  return (
    <ModalWindow
      onClose={onClose}
      header={
        <Heading size={600}>
          <Icon color="#606fc7" type="info-outline" /> Can’t find your artist?
        </Heading>
      }
      width="small"
      isOpen
    >
      <p className={styles.findArtistText}>
        Artists in DISCO are created through the artist metadata on a track. If
        you’re not seeing the artist profile you’re looking for, make sure
        you’ve filled out the artist metadata fields on your tracks.
      </p>

      <p className={styles.findArtistText}>
        For more information about how artists work in DISCO
        <br />
        <a
          className="text-link"
          href="https://support.disco.ac/home/artists-and-artist-profiles"
          rel="noopener noreferrer"
          target="_blank"
        >
          read more here.
        </a>
      </p>
      <ButtonContainer alignRight>
        <Button appearance="help" caption="Got it" onClick={onClose} />
      </ButtonContainer>
    </ModalWindow>
  )
}

export default FindArtist
